import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { doubleParagraphRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type DoubleParagraphProps = HTMLAttributes<HTMLDivElement> & {
  alignment: 'left' | 'right'
  title: string
  subtitle: string
  text_left: string
  text_right: string
}

const DoubleParagraph = ({
  alignment,
  title,
  subtitle,
  text_left,
  text_right,
  ...props
}: DoubleParagraphProps) => {
  return (
    <Motion animation={doubleParagraphRevealAnimation}>
      <Section {...props}>
        <Container>
          <div className={cn('flex flex-col gap-spacing-md md:gap-spacing-lg')}>
            <Grid>
              <div
                className={cn(
                  'col-span-4 flex flex-col gap-spacing-sm',
                  'md:col-span-3',
                  'lg:col-span-6',
                  alignment === 'right' && 'md:col-start-4 lg:col-start-7'
                )}
              >
                <Typography variant="h5">{title}</Typography>
                <Typography variant="large" className="font-medium text-text-accent-light-dark">
                  {subtitle}
                </Typography>
              </div>
            </Grid>
            <Grid>
              <div className={cn('col-span-4', 'md:col-span-3', 'lg:col-span-6')}>
                <Typography variant="regular">{text_left}</Typography>
              </div>
              <div className={cn('col-span-4', 'md:col-span-3', 'lg:col-span-6')}>
                <Typography variant="regular">{text_right}</Typography>
              </div>
            </Grid>
          </div>
        </Container>
      </Section>
    </Motion>
  )
}

export default DoubleParagraph
